import ProjectMessengerAvailability from "./ProjectMessengerAvailability";
import ProjectChatAccessGate from "./ProjectChatAccessGate";
import { mergeChatAccessGateIntoSettings } from "../utils/chatAccessGate";

export default function ProjectTeamAccess({
  gameId,
  value,
  onChange,
  chatAccessSettings,
  onChatAccessChange,
  hintExtra,
  readOnly = false,
  onShareLinkCopied,
  embedded = false,
}) {
  const body = (
    <div className="app-settings-access-body">
      <ProjectMessengerAvailability
        gameId={gameId}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        compact
        showShareLinks
        showShareGuide={false}
        hintExtra={hintExtra}
        onShareLinkCopied={onShareLinkCopied}
      />
      <ProjectChatAccessGate
        settings={chatAccessSettings}
        availableMessengers={value}
        readOnly={readOnly}
        onChange={(gatePatch) => {
          if (!onChatAccessChange) return;
          onChatAccessChange(
            mergeChatAccessGateIntoSettings(chatAccessSettings, gatePatch),
          );
        }}
      />
    </div>
  );

  if (embedded) {
    return body;
  }

  return (
    <div className="app-editor-settings__access-wrap">
      <section className="app-settings-card app-settings-card--access app-settings-card--access-compact">
        <h3 className="app-settings-card__title app-settings-card__title--left">
          Доступ для команды
        </h3>
        {body}
      </section>
    </div>
  );
}
